import { DataStore } from "aws-amplify";
import ClientLoggerFactory from "../../../logging/ClientLoggerFactory";
import PropertyDAO from "../PropertyDAO";
import DataStorePropertyDAO from "./DataStorePropertyDAO";
import MockDataStorePropertyDAO from "./MockDataStorePropertyDAO";

export default class DataStorePropertyDAOFactory {
    private static readonly INSTANCE: PropertyDAO = new DataStorePropertyDAO(
        DataStore,
        ClientLoggerFactory.getClientLogger("DataStorePropertyDAO"),
    );
    private static readonly MOCK_INSTANCE: PropertyDAO = new MockDataStorePropertyDAO(
        ClientLoggerFactory.getClientLogger("MockDataStorePropertyDAO"),
    );

    public static getInstance(): PropertyDAO {
        if (process.env.REACT_APP_MOCK_ENABLED === "true") {
            return this.MOCK_INSTANCE;
        } else {
            return this.INSTANCE;
        }
    }
}
